/**
 * Pakt het eerste fenced code-block met de gevraagde taal uit een
 * Claude-response. Spiegelt `extractFencedBlock` uit
 * `apps/worker/src/handlers/aiTransform.ts` — dupliceren omdat de
 * client de aggregatie nu zelf doet (na de switch naar streaming
 * responses, omdat Netlify-edge anders na 26s een 504 gooit voor
 * langlopende non-streaming Anthropic-calls).
 *
 * Houd deze in sync met de worker-versie. Als de extract-logica
 * verandert: pas beide files aan.
 */
export function extractFencedBlock(raw: string, lang: "svg" | "json" | "plantuml"): string | null {
  const lines = raw.split(/\r?\n/);
  let inBlock = false;
  const out: string[] = [];
  for (const line of lines) {
    if (!inBlock) {
      const m = line.match(/^\s*```\s*(\w+)\b/);
      const fence = m?.[1]?.toLowerCase();
      // Een SVG komt ook wel in een xml- of html-blok.
      if (fence === lang || (lang === "svg" && (fence === "xml" || fence === "html"))) {
        inBlock = true;
      }
      continue;
    }
    if (/^\s*```\s*$/.test(line)) {
      return out.join("\n").trim();
    }
    out.push(line);
  }
  // Geen codeblok: een losse, complete <svg>…</svg> is ook goed.
  if (lang === "svg") {
    const start = raw.indexOf("<svg");
    const end = raw.lastIndexOf("</svg>");
    if (start !== -1 && end > start) return raw.slice(start, end + "</svg>".length).trim();
  }
  return null;
}
